import LegalPage from "../../components/legal/LegalPage";
import document from "../../content/legal/privacy-policy.json";

export default function Page() {
  return <LegalPage title="Privacy Policy" document={document} />;
}
